import React, { ReactChild } from "react";

export interface DropDownMenuProps {
  menuItems: {
    icon?: ReactChild;
    text: string;
    onClick?: () => void;
  }[];
}

export default function DropDownMenu(props: DropDownMenuProps) {
  return (
    <div className="relative h-24 w-[165px] drop-shadow-lg z-25">
      <Polygon1 />
      <div className="absolute top-2.5 left-[0] inline-flex flex-col items-start justify-start gap-2 rounded-lg bg-white pl-[17px] pr-[17px] pt-[15px] pb-[15px]">
        {props.menuItems.map((menuItem, idx) => {
          return (
            <IconText
              key={idx}
              text={menuItem.text}
              icon={menuItem.icon}
              onClick={menuItem.onClick}
            />
          );
        })}
      </div>
    </div>
  );
}

function IconText(props: IconTextInterface) {
  return (
    <div className="inline-flex" onClick={props.onClick}>
      <div className="flex items-center justify-start gap-2.5 overflow-clip">
        {props.icon}
        <p className="text-center font-['Poppins'] text-base font-medium leading-[1.5] text-[rgba(50,50,50,1)]">
          {props.text}
        </p>
      </div>
    </div>
  );
}

interface IconTextInterface {
  onClick?: () => void;
  text: string;
  icon?: ReactChild;
}

export function Polygon1() {
  return (
    <div className="absolute left-[11px] top-[0] h-3.5 w-[18px]">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 0L15.7942 10.5H0.205771L8 0Z" fill="#FFFEFC" />
      </svg>
    </div>
  );
}
